import React, { memo } from "react";
import isempty from "lodash/isEmpty";
import { ORDERS_NS as ns } from "@/i18n/ns";
import PT from "prop-types";
import Accordion from "_c/Accordion";

const CustomFields = ({ isTaskConsumer, customFields, t }) => {
  if (isTaskConsumer || isempty(customFields)) {
    return null;
  }
  return (
    <Accordion
      css={`
        margin-bottom: 0;
        margin-top: 10px;
        > button {
          box-shadow: none;
          background: ${({ theme }) => theme.color.positive};
        }
        strong {
          font-weight: 500;
        }
      `}
      title={t(`${ns}:custom_fields`)}
    >
      <ul>
        {customFields.map((field, idx) => (
          <li
            css={`
              margin-bottom: 7px;
              :last-child {
                margin-bottom: 0;
              }
            `}
            key={idx}
          >
            <div
              css={`
                font-weight: 700;
                margin-bottom: 2px;
              `}
            >
              {field.key}:
            </div>
            <div>{field.value}</div>
          </li>
        ))}
      </ul>
    </Accordion>
  );
};
CustomFields.propTypes = {
  customFields: PT.array,
  isTaskConsumer: PT.bool,

  t: PT.func.isRequired,
};

export default memo(CustomFields);
